import { ColumnsType } from "src/interfaces/Common";

export const getCustomFieldsColumns = (data: any[]): ColumnsType[] => {
  if (!data || data.length === 0) return [];

  const customFieldsMap = new Map<
    number,
    { fieldId: number; fieldName: string }
  >();

  data.forEach((item) => {
    if (item?.customFields) {
      item.customFields.forEach((field: any) => {
        if (!customFieldsMap.has(field.fieldId)) {
          customFieldsMap.set(field.fieldId, {
            fieldId: field.fieldId,
            fieldName: field.fieldName,
          });
        }
      });
    }
  });

  return Array.from(customFieldsMap.values()).map((field) => ({
    accessorKey: `customFields.${field.fieldId}`,
    id: `customFields_${field.fieldId}`,
    disabledSelection: false,
    form_box: [],
    hasFilter: false,
    header: field.fieldName,
    labelHeader: {
      en: field.fieldName,
      it: field.fieldName,
    },
    accessorFn: (row: any) => {
      const customField = row.customFields?.find(
        (cf: any) => cf.fieldId === field.fieldId,
      );
      return customField?.fieldValue || "";
    },
  }));
};
